import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { key: 1 };
import { computed, inject, onMounted, reactive, ref } from "vue";
import { Formatter } from "@/util/Formatter";
import { OrderStatus } from "@/model/enum/OrderStatus";
import Order from "@/model/Order.model";
import OrderList from "@/components/admin/OrderList.vue";
import { useUserStore } from "@/stores/UserStore";
import { Authorities } from "@/model/User.model";
import { OrderServiceSymbol, StatisticsServiceSymbol } from "@/InjectionSymbols";
export default /*@__PURE__*/ _defineComponent({
    __name: 'DashboardView',
    setup(__props) {
        const orderService = inject(OrderServiceSymbol);
        const statisticsService = inject(StatisticsServiceSymbol);
        const userStore = useUserStore();
        const orderStats = ref(null);
        const newOrders = reactive([]);
        const firstYear = ref(new Date().getFullYear().valueOf());
        const statsYear = ref(new Date().getFullYear().valueOf());
        onMounted(() => {
            if (userStore.hasAuthority(Authorities.PRIVILEGE_ORDER_STATISTICS)) {
                loadOrderStats(statsYear.value);
            }
            orderService.loadOrders()
                .then((response) => {
                response.data.forEach(order => {
                    const typedOrder = new Order();
                    typedOrder.assign(order);
                    // Find order with earlierst contract year
                    if (typedOrder.contract != undefined && typedOrder.contract.contractYear < firstYear.value) {
                        firstYear.value = typedOrder.contract.contractYear;
                    }
                    if (typedOrder.orderStatus === OrderStatus.NEW) {
                        newOrders.push(typedOrder);
                    }
                });
            });
        });
        const bookingStatsRows = computed(() => {
            return new Set([...Object.keys(orderStats.value?.totalOrdered ?? {}), ...Object.keys(orderStats.value?.totalPayed ?? {})]);
        });
        function loadOrderStats(year) {
            orderStats.value = null;
            statisticsService.getOrderStatistics(year)
                .then((response) => {
                orderStats.value = response.data;
            });
        }
        return (_ctx, _cache) => {
            const _component_v_container = _resolveComponent("v-container");
            const _component_v_select = _resolveComponent("v-select");
            const _component_v_progress_circular = _resolveComponent("v-progress-circular");
            const _component_v_table = _resolveComponent("v-table");
            const _component_v_card = _resolveComponent("v-card");
            return (_openBlock(), _createBlock(_component_v_card, null, {
                default: _withCtx(() => [
                    _createVNode(_component_v_container, {
                        fluid: true,
                        class: "d-flex flex-wrap ma-0 pa-0"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_container, { class: "text-h4 text-start v-col-12" }, {
                                default: _withCtx(() => _cache[2] || (_cache[2] = [
                                    _createTextVNode(" Dashboard ")
                                ])),
                                _: 1
                            }),
                            _createVNode(_component_v_container, { class: "d-flex v-col-12 pt-0 ma-0" }, {
                                default: _withCtx(() => [
                                    (_unref(userStore).hasAuthority(_unref(Authorities).PRIVILEGE_ORDER_STATISTICS))
                                        ? (_openBlock(), _createBlock(_component_v_card, {
                                            key: 0,
                                            class: "pa-4 pt-2"
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_container, { class: "pl-0 pt-0 d-flex" }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_v_container, { class: "pa-0 ma-0 pt-2 pr-4 text-start font-weight-bold text-h5" }, {
                                                            default: _withCtx(() => _cache[3] || (_cache[3] = [
                                                                _createTextVNode("Buchungsstatistik")
                                                            ])),
                                                            _: 1
                                                        }),
                                                        _createVNode(_component_v_select, {
                                                            style: { "min-width": "100px" },
                                                            class: "",
                                                            label: "Jahr",
                                                            modelValue: statsYear.value,
                                                            "onUpdate:modelValue": [
                                                                _cache[0] || (_cache[0] = ($event) => ((statsYear).value = $event)),
                                                                _cache[1] || (_cache[1] = () => loadOrderStats(statsYear.value))
                                                            ],
                                                            items: Array.from({ length: new Date().getFullYear().valueOf() - firstYear.value + 1 }, (v, k) => k + firstYear.value),
                                                            variant: "outlined",
                                                            density: "compact"
                                                        }, null, 8, ["modelValue", "items"])
                                                    ]),
                                                    _: 1
                                                }),
                                                (!orderStats.value)
                                                    ? (_openBlock(), _createBlock(_component_v_container, {
                                                        key: 0,
                                                        class: "justify-center"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_v_progress_circular, { indeterminate: true })
                                                        ]),
                                                        _: 1
                                                    }))
                                                    : _createCommentVNode("", true),
                                                (orderStats.value)
                                                    ? (_openBlock(), _createBlock(_component_v_table, {
                                                        key: 1,
                                                        style: { "text-align": "left" },
                                                        class: "w-100"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _cache[4] || (_cache[4] = _createElementVNode("tr", null, [
                                                                _createElementVNode("th", null, "Konto"),
                                                                _createElementVNode("th", null, "Auftragseingang"),
                                                                _createElementVNode("th", null, "Zahlungseingang")
                                                            ], -1)),
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bookingStatsRows.value, (ledger, index) => {
                                                                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                                                    _createElementVNode("td", null, _toDisplayString(ledger), 1),
                                                                    (orderStats.value)
                                                                        ? (_openBlock(), _createElementBlock("td", _hoisted_1, _toDisplayString(_unref(Formatter).currency(orderStats.value.totalOrdered[ledger])), 1))
                                                                        : _createCommentVNode("", true),
                                                                    (orderStats.value)
                                                                        ? (_openBlock(), _createElementBlock("td", _hoisted_2, _toDisplayString(_unref(Formatter).currency(orderStats.value.totalPayed[ledger])), 1))
                                                                        : _createCommentVNode("", true)
                                                                ]));
                                                            }), 128))
                                                        ]),
                                                        _: 1
                                                    }))
                                                    : _createCommentVNode("", true)
                                            ]),
                                            _: 1
                                        }))
                                        : _createCommentVNode("", true)
                                ]),
                                _: 1
                            }),
                            _createVNode(_component_v_container, { class: "d-flex v-col-12" }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_card, { class: "mr-2 pa-4" }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_container, { class: "text-start font-weight-bold pl-0 pt-0 text-h5" }, {
                                                default: _withCtx(() => _cache[5] || (_cache[5] = [
                                                    _createTextVNode("Neue Buchungseingänge")
                                                ])),
                                                _: 1
                                            }),
                                            _createVNode(OrderList, {
                                                orders: newOrders,
                                                class: "w-auto"
                                            }, null, 8, ["orders"])
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }));
        };
    }
});
